var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { observable, runInAction } from 'mobx';
const QUERY_STRING_PREFIX = 'form_';
let FormPrefilledDataStore = (() => {
    var _a, _FormPrefilledDataStore_status_accessor_storage;
    let _status_decorators;
    let _status_initializers = [];
    let _status_extraInitializers = [];
    return _a = class FormPrefilledDataStore {
            get status() { return __classPrivateFieldGet(this, _FormPrefilledDataStore_status_accessor_storage, "f"); }
            set status(value) { __classPrivateFieldSet(this, _FormPrefilledDataStore_status_accessor_storage, value, "f"); }
            constructor(rootStore) {
                _FormPrefilledDataStore_status_accessor_storage.set(this, __runInitializers(this, _status_initializers, 'UNINITIALIZED'));
                Object.defineProperty(this, "cmsDataStore", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: __runInitializers(this, _status_extraInitializers)
                });
                Object.defineProperty(this, "contactInfoStore", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                Object.defineProperty(this, "propStateStore", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: void 0
                });
                this.cmsDataStore = rootStore.cmsDataStore;
                this.contactInfoStore = rootStore.contactInfoStore;
                this.propStateStore = rootStore.propStateStore;
            }
            getCmsDataStoreKey(type) {
                return `technicalParameter_${type}`;
            }
            setCmsValue(key, value) {
                this.cmsDataStore.setData(key, value);
            }
            clearTechnicalParameters() {
                this.cmsDataStore.clearDataWithPrefix('technicalParameter_');
            }
            async getContactInfo() {
                var _b, _c;
                if (this.status === 'FETCHING') {
                    return;
                }
                runInAction(() => (this.status = 'FETCHING'));
                await this.contactInfoStore.fetchContactInfo((_c = (_b = this.propStateStore.clientAuth) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.customerId);
                runInAction(() => (this.status = 'FETCHED'));
            }
            mapPrefilledValuesForAnyone(technicalParameter) {
                switch (technicalParameter) {
                    case 'referer':
                        return this.propStateStore.pathname ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), this.propStateStore.pathname) : null;
                    default:
                        return;
                }
            }
            mapPrefilledValuesForLoggedInUser(technicalParameter) {
                const email = this.contactInfoStore.email;
                const phone = this.contactInfoStore.phone;
                if (this.propStateStore.clientAuth) {
                    const auth = this.propStateStore.clientAuth;
                    switch (technicalParameter) {
                        case 'person_name':
                            return auth.person && auth.person.displayName ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.person.displayName) : null;
                        case 'representative_email':
                            return email ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), email) : null;
                        case 'representative_phone':
                            return phone ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), phone) : null;
                        case 'person_regcode':
                            return auth.person && auth.person.personalCode ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.person.personalCode) : null;
                        case 'person_regcode_country':
                            return auth.person && auth.person.personalCodeCountryCode
                                ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.person.personalCodeCountryCode)
                                : null;
                        case 'company_name':
                            return this.ifExistsCustomer('B2B') && auth.customer.displayName
                                ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.customer.displayName)
                                : null;
                        case 'company_regcode':
                            return this.ifExistsCustomer('B2B') && auth.customer.registrationNumber
                                ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.customer.registrationNumber)
                                : null;
                        case 'company_person_name':
                            return auth.person && auth.person.displayName && auth.customer.type === 'B2B'
                                ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.person.displayName)
                                : null;
                        case 'representative':
                            return auth.person && auth.person.displayName ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.person.displayName) : null;
                        case 'represented':
                            return auth.customer && auth.customer.displayName ? this.setCmsValue(this.getCmsDataStoreKey(technicalParameter), auth.customer.displayName) : null;
                        default:
                            return;
                    }
                }
            }
            async mapPrefilledValues(technicalParameter) {
                this.mapPrefilledValuesForAnyone(technicalParameter);
                this.mapPrefilledValuesForLoggedInUser(technicalParameter);
            }
            mapPrefilledValuesFromQueryStrings(form) {
                for (const [key, value] of Object.entries(this.propStateStore.decodedParams)) {
                    this.fillMatchingFormFields(form, key, value);
                    this.addPrefilledCustomerId(form, key, value);
                }
            }
            addPrefilledCustomerId(form, key, value) {
                if (key === 'customer_id') {
                    form.prefilledCustomerId = value;
                }
            }
            fillMatchingFormFields(form, key, value) {
                const matchingField = form.fields.find((field) => field.label.toLowerCase() === _a.getLabelFromQueryKey(key));
                matchingField && value && this.setFieldValueFromQueryString(value, matchingField);
            }
            setFieldValueFromQueryString(value, field) {
                switch (field.type) {
                    case 'multiselect':
                    case 'checkbox':
                        const values = _a.createArrayFromValue(value);
                        field.choices.filter((choice) => values.includes(choice.text)).map((choice) => (choice.isSelected = true));
                        break;
                    case 'select':
                    case 'radio':
                        const matchingChoice = field.choices.find((choice) => choice.text === value);
                        if (matchingChoice) {
                            matchingChoice.isSelected = true;
                        }
                        break;
                    case 'html':
                        console.warn('HTML field filling from query string is not supported');
                        break;
                    default:
                        if (field) {
                            field.setValue(value);
                        }
                }
            }
            static createArrayFromValue(value) {
                if (value.startsWith('[') && value.endsWith(']')) {
                    return value.substring(1, value.length - 1).split(',');
                }
                return [value];
            }
            static getLabelFromQueryKey(key) {
                if (key.startsWith(QUERY_STRING_PREFIX)) {
                    return key.split(QUERY_STRING_PREFIX)[1].toLowerCase();
                }
            }
            ifExistsCustomer(customerType) {
                var _b, _c;
                return ((_c = (_b = this.propStateStore.clientAuth) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.type) === customerType;
            }
        },
        _FormPrefilledDataStore_status_accessor_storage = new WeakMap(),
        (() => {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _status_decorators = [observable];
            __esDecorate(_a, null, _status_decorators, { kind: "accessor", name: "status", static: false, private: false, access: { has: obj => "status" in obj, get: obj => obj.status, set: (obj, value) => { obj.status = value; } }, metadata: _metadata }, _status_initializers, _status_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { FormPrefilledDataStore };
export default FormPrefilledDataStore;
//# sourceMappingURL=FormPrefilledDataStore.js.map